export const INITIAL_APP_RECT_VALUE = {
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
    x: 0,
    y: 0
};
export const INITIAL_APP_CONTEXT = {
    ...INITIAL_APP_RECT_VALUE,
    screenWidth: null,
    screenHeight: null,
    isDev: null,
    isTouchDevice: null,
    isWebPSupported: null,
    appElement: null,
    browserName: null
};
